import { render, staticRenderFns } from "./achievementCard.vue?vue&type=template&id=0033d641&scoped=true&"
import script from "./achievementCard.vue?vue&type=script&lang=js&"
export * from "./achievementCard.vue?vue&type=script&lang=js&"
import style0 from "./achievementCard.vue?vue&type=style&index=0&id=0033d641&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0033d641",
  null
  
)

export default component.exports